import { render, staticRenderFns } from "./Lgx196029060764139520.vue?vue&type=template&id=2a9e1fc4&scoped=true&"
import script from "./Lgx196029060764139520.vue?vue&type=script&lang=js&"
export * from "./Lgx196029060764139520.vue?vue&type=script&lang=js&"
import style0 from "./Lgx196029060764139520.vue?vue&type=style&index=0&id=2a9e1fc4&prod&lang=scss&scoped=true&"
import style1 from "./Lgx196029060764139520.vue?vue&type=style&index=1&id=2a9e1fc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9e1fc4",
  null
  
)

export default component.exports